interface DefineShowTbdLabelProp {
    iqtModeOn: boolean;
    isIqtModeTbdShown: boolean;
    isTbd: boolean;
}

export function defineShowTbdLabel({ iqtModeOn, isIqtModeTbdShown, isTbd }: DefineShowTbdLabelProp) {
    if ((iqtModeOn && !isIqtModeTbdShown) || !isTbd) return { showPrice: true, showTbdLabel: false };
    if (iqtModeOn && isIqtModeTbdShown) return { showPrice: true, showTbdLabel: true };
    return { showPrice: false, showTbdLabel: true };
}
